import {  GET_CART} from '../actions/types';

const cart_data = {
  data: [],
};

export default (state = cart_data, action) => {
  switch (action.type) {   
    case GET_CART:         
      var  newdata = action.payload.dataArray 
      return {  
        origData:newdata,
        data: newdata,
      };

    default:
      return state;
  }
};
